import { Box, Stack } from "@mui/material";
import { Send } from "@mui/icons-material";
import SidebarActionItemCard from "./SidebarActionItemCard";
import { BookingData } from "../../types/view-booking";
import { SidebarActionItem } from "../types/sidebar.types";
import { CalendarIcon } from "../../../../components/icons/CalendarIcon";
import { MessageIcon } from "../../../../components/icons/MessageIcon";
import { useState } from "react";
import RequestClientReviewModal from "./RequestClientReviewModal";

interface BookingSidebarProps {
  bookingData?: BookingData | null;
}

export default function BookingSidebar({ bookingData }: BookingSidebarProps) {
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const deceased = bookingData?.beloved;
  const dateOfDeath = deceased?.details?.dateOfDeath;

  const getDaysUntilAnniversary = (dod: string): number | null => {
    if (!dod || dod === "N/A") return null;
    const [day, month, year] = dod.split("-");
    const death = new Date(Number(year), Number(month) - 1, Number(day));
    if (isNaN(death.getTime())) return null;
    const today = new Date();
    const next = new Date(
      today.getFullYear(),
      death.getMonth(),
      death.getDate(),
    );
    if (next <= today) next.setFullYear(today.getFullYear() + 1);
    return Math.ceil(
      (next.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
    );
  };

  const daysUntil = dateOfDeath ? getDaysUntilAnniversary(dateOfDeath) : null;

  const actionItems: SidebarActionItem[] = [
    {
      icon: <CalendarIcon sx={{ color: "#007AFF" }} />,
      title:
        daysUntil !== null
          ? `${daysUntil} days until ${deceased?.name}'s anniversary`
          : "No anniversary data available",
      subtitle: "Send message to family",
      onClick: () => {},
    },
    {
      icon: <MessageIcon sx={{ color: "#E11D48" }} />,
      title: "Request Client review",
      subtitle: "Gather insights from client for future improvements",
      onClick: () => setReviewModalOpen(true),
    },
    {
      icon: <Send sx={{ color: "#724E41" }} />,
      title: "Send Thank you message to client",
      subtitle: "Reflect on project outcomes and team",
      onClick: () => {},
    },
  ];

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stack spacing={1}>
          {actionItems.map((item, index) => (
            <SidebarActionItemCard key={index} item={item} />
          ))}
        </Stack>
      </Box>
      <RequestClientReviewModal
        open={reviewModalOpen}
        onClose={() => setReviewModalOpen(false)}
        bookingData={bookingData}
      />
    </>
  );
}
